/**
 * Кастомные события, которые могут быть перехвачены в приложении
 * Никакой критичной информации через них передавать нельзя
 */
export enum CustomEventName {
  IncidentIdError = 'IncidentIdError',
}
